/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L7_Feat2_BodyInputs */

const es_l7_feat2_body = /** @type {(inputs: L7_Feat2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La subcontratamos y la llevamos por ti, para que tu barco cumpla sin que tengas que perseguir a nadie.`)
};

const gl_l7_feat2_body = /** @type {(inputs: L7_Feat2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subcontratámola e lévamola por ti, para que o teu barco cumpra sen ter que perseguir a ninguén.`)
};

const en_l7_feat2_body = /** @type {(inputs: L7_Feat2_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We arrange it and handle it for you, so your boat complies without you chasing anyone.`)
};

/**
* | output |
* | --- |
* | "We arrange it and handle it for you, so your boat complies without you chasing anyone." |
*
* @param {L7_Feat2_BodyInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l7_feat2_body = /** @type {((inputs?: L7_Feat2_BodyInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L7_Feat2_BodyInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l7_feat2_body(inputs)
	if (locale === "en") return en_l7_feat2_body(inputs)
	return es_l7_feat2_body(inputs)
});